import { Audit } from '../../auth';
import { IssueCreationSource } from '../../graphql';
import { WorkspaceRoutine } from './workspaceRoutine';

export interface AssetRoutine extends Audit {
  data: any;
  routine: WorkspaceRoutine;
  routineVersion: WorkspaceRoutine;
  exceptionCount?: number;
  id?: string;
  /**
   * Provenance of the reading. Integration sources (GEOTAB, JOHN_DEERE) select
   * which readings surface as the asset's reading-activity rows; the author
   * identity carries the provenance (there is no on-row attribution tag).
   * Absent for manually-entered readings.
   */
  createdFrom?: IssueCreationSource;
}

export interface AssetRoutines {
  count: number;
  items: AssetRoutine[];
}
